import Image from "next/image"
import { config } from "@/config"
import brandIcon from "@/public/icons/icon-192.png"

import { cn } from "@/lib/utils"

interface BrandIconProps {
  className?: string
  priority?: boolean
}

export function BrandIcon({ className, priority = false }: BrandIconProps) {
  return (
    <Image
      src={brandIcon}
      alt={`${config.name} - ${config.slogan}`}
      priority={priority}
      width={32}
      height={32}
      className={cn("size-8 shrink-0 rounded-lg", className)}
    />
  )
}
